import { StringParam, useQueryParam, withDefault } from "use-query-params";

export const useQuickFiltersQueryParams = () => {
  const [quickFilterId, setQuickFilterId] = useQueryParam(
    "quickFilterId",
    withDefault(StringParam, ""),
    { updateType: "pushIn" },
  );

  return {
    quickFilterId,
    setQuickFilterId,
  };
};
